import { FormProps } from '@shared/components/form/types';
import { MultiSelect, MultiSelectProps } from '@shared/components/multi-select';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@shared/components/ui/form';
import { cn } from '@shared/lib/utils';
import { useFormContext } from 'react-hook-form';

interface MultiGoodsPickerProps extends FormProps {
  multiSelectProps?: Partial<MultiSelectProps>;
}

const options = [
  { value: 'food', label: 'Food and drink' },
  { value: 'packaging', label: 'Packaging' },
];

function MultiGoodsPicker({
  name,
  className,
  label,
  includeErrorMessage,
  multiSelectProps,
}: MultiGoodsPickerProps) {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormItem className={cn('grid flex-1 items-center', className)}>
            {label && <FormLabel>{label}</FormLabel>}
            <FormControl>
              <MultiSelect
                options={options}
                onValueChange={field.onChange}
                defaultValue={field.value}
                placeholder="All goods included"
                className=" bg-gray-00"
                autoSize
                responsive
                maxWidth="100%"
                hideSelectAll
                searchable={false}
                {...multiSelectProps}
              />
            </FormControl>
            {includeErrorMessage && <FormMessage />}
          </FormItem>
        );
      }}
    />
  );
}

export default MultiGoodsPicker;
